export class AssetChartSettingRequestModel {
	public pageName!: string;
	constructor() {}
}